import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Constanst } from 'src/app/core/constants/constans.component';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { BudgetItem } from 'src/app/shared/models/partida-presupuesto';
import { Select } from 'src/app/shared/models/select';

@Component({
  selector: 'app-modificar-partida-presupuesto',
  templateUrl: './modificar-partida-presupuesto.component.html',
  styleUrls: ['./modificar-partida-presupuesto.component.css']
})
export class ModificarPartidaPresupuestoComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  updateLineItemBudgetForm: FormGroup;
  reference: string = '';
  listLineItemsBudget: BudgetItem[] = [];

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  activeLineItemsBudget: string = '';
  selectedLineItemBudget = new FormControl('0');
  listSelectLineItemsBudget: Select[] = [];
  disablePrevious = false;
  disableNext = false;
  currentSlide = 0;
  idCurrentSlide: number = 0;
  quantitySlide: number = 0;
  descriptionSlide: string = '';
  referenceSlide: string = '';
  priceSlide: number = 0;
  price: number = 0;
  total: number = 0;
  quantity: number = 0;
  classFlag: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public pPartida: BudgetItem,
    public dialogModificarPartidaPresupuestoRef: MatDialogRef<ModificarPartidaPresupuestoComponent>,
    private cachePartidasService: CachePartidasService,
    private helperClassService: HelperClassService
  ) { }

  ngOnInit() {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    this.cachePartidasService.getAll().subscribe((data: BudgetItem[]) => {
      this.listLineItemsBudget = data;
    });
    this.updateLineItemBudgetForm = new FormGroup({
      quantity: new FormControl({ value: '', disabled: true }),
      description: new FormControl({ value: '', disabled: true }),
      reference: new FormControl({ value: '', disabled: true })
    });
    this.consultLineItemDetails();
    this.loadListBudgetLineItems();
  }

  loadListBudgetLineItems() {
    let lista = this.listLineItemsBudget;
    for (let i = 0; i < lista.length; i++) {
      let budget: Select = { id: '', value: '' };
      budget.id = String(lista[i].idLineItem);
      budget.value = ('Partida Nro ' + (i + 1));
      this.listSelectLineItemsBudget.push(budget);

      if (lista[i].idLineItem == Number(this.selectedLineItemBudget)) {
        this.currentSlide = (i + 1);
      }
    }
  }

  onSubmit(): void {
    if (this.updateLineItemBudgetForm.invalid) {
      return;
    } else {
      if (Number(this.updateLineItemBudgetForm.controls['quantity'].value) > 0) {
        return this.confirm();
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_GREATER_ZERO, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  confirm() {
    let valorLineItem = (this.idCurrentSlide == 0 ? this.pPartida.idLineItem : this.idCurrentSlide);
    for (let i = 0; i < this.listLineItemsBudget.length; i++) {
      if (this.listLineItemsBudget[i].idLineItem == valorLineItem) {
        this.listLineItemsBudget[i].quantity = Number(this.updateLineItemBudgetForm.controls['quantity'].value);
        this.listLineItemsBudget[i].total = (this.listLineItemsBudget[i].quantity * this.listLineItemsBudget[i].unitPrice);
        this.cachePartidasService.modify(this.listLineItemsBudget[i].idLineItem.toString(), this.listLineItemsBudget[i]);
        break;
      }
    }
  }

  closeDialogModificarPartidaPresupuesto() {
    this.dialogModificarPartidaPresupuestoRef.close();
  }

  ngOnDestroy(): void {
    this.closeDialogModificarPartidaPresupuesto();
  }

  consultLineItemDetails() {
    let valorLineItem = (this.idCurrentSlide == 0 ? this.pPartida.idLineItem : this.idCurrentSlide);
    //Opcion por defecto en el select de partidas del presupuesto
    this.activeLineItemsBudget = String(valorLineItem);
    this.setCurrentSlide(valorLineItem);

    this.reference = (this.idCurrentSlide == 0 ? this.pPartida.reference : this.referenceSlide);
    this.quantity = (this.idCurrentSlide == 0 ? this.pPartida.quantity : this.quantitySlide);
    this.price = (this.idCurrentSlide == 0 ? this.pPartida.unitPrice : this.priceSlide);
    this.total = this.quantity * this.price;

    this.updateLineItemBudgetForm = new FormGroup({
      quantity: new FormControl({ value: this.quantity, disabled: false }, [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS)]),
      description: new FormControl({ value: (this.idCurrentSlide == 0 ? this.pPartida.description : this.descriptionSlide), disabled: true }),
      reference: new FormControl({ value: (this.idCurrentSlide == 0 ? this.pPartida.reference : this.referenceSlide), disabled: true })
    });

    //Activar o desactivar boton next paginacion
    if (this.currentSlide == this.listLineItemsBudget.length) {
      this.disableNext = true;
    } else {
      this.disableNext = false;
    }
    //Activar o desactivar boton previous paginacion
    if (this.currentSlide == 1) {
      this.disablePrevious = true;
    } else {
      this.disablePrevious = false;
    }
  }

  private setIdCurrentSlide(index: number) {
    this.idCurrentSlide = this.listLineItemsBudget[(index - 1)].idLineItem;
    this.quantitySlide = this.listLineItemsBudget[(index - 1)].quantity;
    this.descriptionSlide = this.listLineItemsBudget[(index - 1)].description;
    this.referenceSlide = this.listLineItemsBudget[(index - 1)].reference;
    this.priceSlide = this.listLineItemsBudget[(index - 1)].unitPrice;
  }

  private setCurrentSlide(id: number) {
    for (let i = 0; i < this.listLineItemsBudget.length; i++) {
      if (this.listLineItemsBudget[i].idLineItem == id) {
        this.currentSlide = i + 1;
        break;
      }
    }
  }

  onChangeSelect() {
    this.idCurrentSlide = Number(this.selectedLineItemBudget.value);
    this.setCurrentSlide(this.idCurrentSlide);
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  onFirstClick() {
    this.currentSlide = 1;
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  onPreviousClick() {
    this.currentSlide = this.currentSlide - 1;
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  onNextClick() {
    this.currentSlide = this.currentSlide + 1;
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  onLastClick() {
    this.currentSlide = this.listLineItemsBudget.length;
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  calculateAmount() {
    let newQuantity = Number(this.updateLineItemBudgetForm.controls['quantity'].value);
    if (newQuantity > 0) {
      this.total = newQuantity * this.price;
    }
  }

}
